import { render, staticRenderFns } from "./OrdersState.vue?vue&type=template&id=b38bc6a0&scoped=true&"
import script from "./OrdersState.vue?vue&type=script&lang=js&"
export * from "./OrdersState.vue?vue&type=script&lang=js&"
import style0 from "./OrdersState.vue?vue&type=style&index=0&id=b38bc6a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38bc6a0",
  null
  
)

export default component.exports